import React from 'react';
import PinnedViews from './PinnedViews';

/**
 * Reusable controls strip for the four project boards (Projects, Closed,
 * AccountsReceivable, Dead). Bundles three pieces that every board needs:
 *
 *  - a slot for the board-specific filter buttons (Edit Filters / Clear
 *    Filters live here because each board's filter shape is different)
 *  - the Pinned Views dropdown
 *  - the "Show N entries" select and the search input
 *
 * Each board owns its own filter and pinned-view state and just hands the
 * relevant props down. Keeps board-level pages from re-implementing the
 * same flex layout (and lets us roll out new controls — like Pinned Views
 * was — by changing one file instead of four).
 */
const BoardControls = ({
  filterButtons,
  pinnedView,        // { board, currentState, onApply }
  columnToggle,      // optional <ColumnToggle /> element
  entriesPerPage,
  setEntriesPerPage,
  searchTerm,
  setSearchTerm,
  searchTestId,
  entriesTestId,
}) => (
  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
    <div className="flex flex-col items-start gap-3">
      <div className="flex flex-wrap items-center gap-3">
        {filterButtons}
        {pinnedView && (
          <PinnedViews
            board={pinnedView.board}
            currentState={pinnedView.currentState}
            onApply={pinnedView.onApply}
          />
        )}
        {columnToggle}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">Show</span>
        <select
          value={entriesPerPage}
          onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1 text-sm"
          data-testid={entriesTestId}
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <span className="text-sm text-gray-600">entries</span>
      </div>
    </div>
    <div className="flex items-center gap-2 w-full sm:w-auto">
      <span className="text-sm text-gray-600">Search:</span>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border border-gray-300 rounded px-3 py-1 text-sm w-full sm:w-64"
        data-testid={searchTestId}
      />
    </div>
  </div>
);

export default BoardControls;
